// The 1D chart code from before the enhanced charts, kept verbatim for the flag-off path. Delete with the flag.
/* eslint-disable no-plusplus */
import moment from 'moment-timezone';

import { OHLCV } from '../../../../models/market-data/types';
import { timeToFloat, timezoneDiffUTCMarketHours } from '../../../../util/DateTimeHelpers';
import { ChartLineData } from '../types';
import { calculateYLabelValue } from '../yScale';

const DAILY_CHART_START_IN_MINUTES = 114;
const DAILY_CHART_MINUTES = [ 120, 132, 144, 156, 168, 180, 192 ];
const DAILY_CHART_HOURS = [ '09:30', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00' ];

const convertExchangeTimeToLocal = (time: string): string => {
  // Convert from America/New_York to local
  const sourceTimezone = 'America/New_York';
  const today = moment.tz(sourceTimezone);
  const [hours, minutes] = time.split(':');
  const exchangeMoment = today.clone().set({ hour: parseInt(hours), minute: parseInt(minutes), second: 0 });
  return exchangeMoment.local().format('HH:mm');
};

export const legacyDailyAxisValues = (lastDailyTime: string): string[] => {
  if (!lastDailyTime) return [ '' ];

  let count = 0;
  const dailyValues: string[] = [];

  // NYSE market hours (09:30 - 16:00)
  dailyValues.push(convertExchangeTimeToLocal(DAILY_CHART_HOURS[0]));

  for (let i = 1; i <= DAILY_CHART_MINUTES[DAILY_CHART_MINUTES.length - 1] - DAILY_CHART_START_IN_MINUTES; i++) {
    if (i + DAILY_CHART_START_IN_MINUTES === DAILY_CHART_MINUTES[count]) {
      dailyValues.push(convertExchangeTimeToLocal(DAILY_CHART_HOURS[count + 1]));
      count++;
    } else {
      dailyValues.push('');
    }
  }

  return dailyValues;
};

const calculateMinutes = (time: number) => (Math.floor(time) * 60 + (Math.round((time % 1) * 100))) / 5;

// eslint-disable-next-line max-len
export const legacyParseOHLCVToLineDataDaily = (data: OHLCV[], minDomain: number, lineDiff: number, lineDataRatio: number): ChartLineData[] => {
  const lineData: ChartLineData[] = [];
  const timeDiff = timezoneDiffUTCMarketHours();
  const lastTime = data[data.length - 1].time;
  const lastTimeInMinutes = calculateMinutes(timeToFloat(lastTime)! - timeDiff);

  let dataIndex = 0;

  for (let index = DAILY_CHART_START_IN_MINUTES; index < lastTimeInMinutes + 1; index++) {
    const timeInMinutes = calculateMinutes(timeToFloat(data[dataIndex].time)! - timeDiff);
    if (timeInMinutes === index) {
      const chartIndex = index - DAILY_CHART_START_IN_MINUTES;
      const { close, volume, time, date } = data[dataIndex];

      lineData.push({
        close,
        volume,
        time,
        x: chartIndex,
        y: calculateYLabelValue(data[dataIndex].close, lineDiff, minDomain, lineDataRatio),
        dateAndTime: `${date} ${time}`,
      });
      dataIndex++;
    }
  }

  return lineData;
};
